import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { useMousePosition } from '../hooks/useScrollAnimations';
import { TypeAnimation } from 'react-type-animation';
import { FaBriefcase, FaEnvelope } from 'react-icons/fa';

const Hero = () => {
  const mousePosition = useMousePosition();
  const [orb1Position, setOrb1Position] = useState({ x: 0, y: 0 });
  const [orb2Position, setOrb2Position] = useState({ x: 0, y: 0 });

  useEffect(() => {
    const x = mousePosition.x / window.innerWidth;
    const y = mousePosition.y / window.innerHeight;

    setOrb1Position({
      x: (x - 0.5) * 15,
      y: (y - 0.5) * 15,
    });

    setOrb2Position({
      x: (x - 0.5) * 30,
      y: (y - 0.5) * 30,
    });
  }, [mousePosition]);

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
        delayChildren: 1.2,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.8, ease: [0.4, 0, 0.2, 1] },
    },
  };

  return (
    <section id="home" className="min-h-screen flex items-center justify-center relative overflow-hidden px-[5%]">
      {/* Animated Background Orbs */}
      <div className="absolute top-0 left-0 w-full h-full opacity-40 pointer-events-none">
        <motion.div
          className="absolute w-[500px] h-[500px] rounded-full blur-[80px] opacity-60 bg-[radial-gradient(circle,_var(--tw-gradient-stops))] from-accent-primary to-transparent top-[-200px] right-[-100px]"
          animate={{
            x: orb1Position.x,
            y: orb1Position.y,
          }}
          transition={{ type: 'spring', stiffness: 50, damping: 20 }}
          style={{ willChange: 'transform' }}
        />
        <motion.div
          className="absolute w-[400px] h-[400px] rounded-full blur-[80px] opacity-60 bg-[radial-gradient(circle,_var(--tw-gradient-stops))] from-accent-secondary to-transparent bottom-[-150px] left-[-100px] animate-float-2"
          animate={{
            x: orb2Position.x,
            y: orb2Position.y,
          }}
          transition={{ type: 'spring', stiffness: 30, damping: 20 }}
          style={{ willChange: 'transform' }}
        />
        <div className="absolute w-[300px] h-[300px] rounded-full blur-[80px] opacity-60 bg-[radial-gradient(circle,_var(--tw-gradient-stops))] from-accent-tertiary to-transparent top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 animate-float-3" />
      </div>

      <motion.div
        variants={containerVariants}
        initial="hidden"
        animate="visible"
        className="relative z-10 max-w-5xl text-center"
      >
        <motion.p
          variants={itemVariants}
          className="text-sm text-accent-primary font-semibold tracking-[3px] uppercase mb-6"
        >
          SOFTWARE DEVELOPER
        </motion.p>

        <motion.h1
          variants={itemVariants}
          className="font-display text-5xl sm:text-6xl md:text-7xl lg:text-8xl font-black leading-tight mb-8"
        >
          Hi, I'm <span className="gradient-text">Pavani Kuruva</span>
        </motion.h1>

        <motion.div
          variants={itemVariants}
          className="text-xl sm:text-2xl md:text-3xl text-text-secondary font-light mb-12 min-h-[4rem] flex items-center justify-center"
        >
          <TypeAnimation
            sequence={[
              'I build full-stack MERN applications',
              2000,
              'I design scalable backend systems',
              2000,
              'I solve complex DSA problems',
              2000,
              'I create optimized web solutions',
              2000,
            ]}
            wrapper="span"
            speed={50}
            repeat={Infinity}
          />
        </motion.div>

        <motion.div variants={itemVariants} className="flex gap-6 justify-center flex-wrap">
          <motion.a
            href="#projects"
            className="btn-primary flex items-center gap-2"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            <FaBriefcase />
            View My Work
          </motion.a>
          <motion.a
            href="#contact"
            className="btn-secondary flex items-center gap-2"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            <FaEnvelope />
            Get In Touch
          </motion.a>
        </motion.div>
      </motion.div>
    </section>
  );
};

export default Hero;
